import { render, staticRenderFns } from "./ChemicalModal.vue?vue&type=template&id=5d21c258&scoped=true&"
import script from "./ChemicalModal.vue?vue&type=script&lang=js&"
export * from "./ChemicalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d21c258",
  null
  
)

export default component.exports